export interface BaseModel {
  id?: string;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string;
}

export enum Brand {
  LOGAME = 'logame',
  B2XBET = 'b2xbet',
  LIDERBET = 'liderbet',
  GERALBET = 'geralbet',
  GERALBETR2M = 'geralbetr2m'
}

export enum FaviconUrl {
  LOGAME = 'assets/favicons/logame-favicon.png',
  B2XBET = 'assets/favicons/b2xbet-favicon.png',
  LIDERBET = 'assets/favicons/liderbet-favicon.png',
  GERALBET = 'assets/favicons/geralbet-favicon.png',
  GERALBETR2M = 'assets/favicons/geralbet-favicon.png',
}

export enum SystemTitle {
  LOGAME = 'Logame - Agent View',
  B2XBET = 'B2xbet - Agent View',
  LIDERBET = 'Liderbet - Agent View',
  GERALBET = 'Geralbet - Agent View',
  GERALBETR2M = 'Geralbet - Agent View',
}

interface ApiResponseBase {
  success: boolean;
  message?: string;
}

export interface ApiResponse<T> extends ApiResponseBase {
  data: T;
}

export interface ApiResponsePageableCustom<T> {
  data: T;
  meta: ApiMetaPageable;
  extra?: any;
}

export interface ApiResponsePageable<T> {
  data: T[];
  meta: ApiMetaPageable;
  extra?: any;
}

interface ApiMetaPageable {
  current_page: number;
  per_page: number;
  path: string;
  from: number;
  to: number;
  total: number;
  last_page: number;
  first_page_url: string;
  next_page_url: string;
  prev_page_url: string;
  last_page_url: string;
}

export interface PageControl {
  page?: number;
  take?: number;
  per_page?: number;
  itemCount?: number;
  pageCount?: number;
  orderField?: string;
  order?: Order;
}

export enum Order {
  ASC = 'asc',
  DESC = 'desc',
}

export interface TableColumn {
  label: string;
  slug: string;
  align: string;
  sortable: boolean;
}

export interface IdName {
  id: string;
  name: string;
}

export type DaysWeekValue =
  | DaysWeek.MONDAY
  | DaysWeek.TUESDAY
  | DaysWeek.WEDNESDAY
  | DaysWeek.THURSDAY
  | DaysWeek.FRIDAY
  | DaysWeek.SATURDAY
  | DaysWeek.SUNDAY;

export enum DaysWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export enum RecurrenceType {
  MONTHLY = 'MONTHLY',
}

export enum Currency {
  BRL = 'BRL',
  USDT = 'USDT',
}

export interface Role {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
  permissions: Permission[];
  users_count?: number;
}

export interface Permission {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface UpdateRolePayload {
  permissions: string[];
}

export enum RoleEnum {
  MASTER = 'Master',
  ADMIN = 'Admin',
  FINANCIAL = 'Financial',
  JURIDICAL = 'Juridical',
  VIEWER = 'Viewer',
  OPERATOR = 'Operator',
  MARKET = 'Market',
  TELEMARKETING = 'Telemarketing',
  AFFILIATE = 'Afiliado',
}
